import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from './config';
import { PageImage } from '../Models/pageimage';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class PageImageService {

  constructor(private http: HttpClient,
              private config: Config) {}

  list(): Observable<PageImage[]> {
    return this.http.get<PageImage[]>(this.config.getURL('pageimages'));
  }
  
  get(id: string): Observable<PageImage> {

    return this.http.get<PageImage>(
      `${this.config.getURL('pageimages')}${id}/`);
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/pageimage.ts